import React from 'react';
import useFormNavigation from './useFormNavigation';

const FormNavigationWrapper = ({ children }) => {

    useFormNavigation();
    return <>{children}</>

}

export default FormNavigationWrapper;
